import { StaffWeightedWorkReport } from './staff-weighted-work.model';

export interface WeightedSnapshotDisplay {
  label: string;
  report: StaffWeightedWorkReport | null;
  message: string;
}

export function weightedSnapshotDisplay(file: any, fallbackLabel: string): WeightedSnapshotDisplay {
  const snapshot = file?.weighted_work;
  return {
    label: file?.saved_file_name || fallbackLabel,
    report: snapshot?.version === 1 && snapshot?.status === 'ready' ? snapshot : null,
    message: snapshot?.reason || 'Weighted work was not captured.'
  };
}
